import { z } from 'zod';
export var SeatApplicationTemplateStatus;
(function (SeatApplicationTemplateStatus) {
    SeatApplicationTemplateStatus["Draft"] = "draft";
    SeatApplicationTemplateStatus["Published"] = "published";
    SeatApplicationTemplateStatus["Archived"] = "archived";
})(SeatApplicationTemplateStatus || (SeatApplicationTemplateStatus = {}));
// Create validation and DTO type
export const seatApplicationTemplateCreateSchema = z.object({
    name: z.string('Name is required').min(1, 'Name is required'),
    description: z.string().nullish(),
    requiresSignature: z.boolean().optional(),
    signatureTerms: z.string().nullish(),
});
// Update validation and DTO type
export const seatApplicationTemplateUpdateSchema = seatApplicationTemplateCreateSchema.partial();
export const seatApplicationTemplateMeetingBodyAssignmentSchema = z.object({
    meetingBodyIds: z.array(z.number()),
});
